module.exports = __webpack_public_path__ + "static/img/shopvidi_logo.9a531f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopvidi_logo.png
// module id = KcE/
// module chunks = 2